import * as React from 'react';
import ZoomOutOutlined from './zoom-out-outlined';
import ZoomOutFilled from './zoom-out-filled';
import type { IconCombinedProps } from './types';
const ZoomOutCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ZoomOutFilled ref={ref} {...rest} />;
  }
  return <ZoomOutOutlined ref={ref} {...rest} />;
});
export default ZoomOutCombined;